<template>
  <div class="footer">
  <div class="topColor"></div>
      <div class="banxin">
           <p>
                <a href="http://www.linyimart.gov.cn/index.jsp/"  target="_blank">临沂商城管理委员会</a><span> | </span>
                <a href="http://www.sckgjt.cn/"  target="_blank">临沂商城控股集团有限公司</a><span> | </span>
                <a href="http://www.huishangit.com/"  target="_blank">临沂慧商物流信息技术有限公司</a>
            </p>
            <p>Copyright © 2018 - 2022 <a href="https://www.mlinyi.com/" target="_blank">沂商通mlinyi.com</a> 版权所有</p>
            <p>备案号：<a href="https://beian.miit.gov.cn/#/" target="_blank">鲁ICP备15027601号-5</a></p>
        <!-- <div class="top">
             <div class="leftBox">
                <p class="title">客服电话</p>
                <p class="number">188 1411 4118</p>
                <p class="time">09:00-23:00</p>
                <div class="consult">咨询客服</div>
            </div>
             <div class="centerBox">
                <p class="title">关注CERESHOP</p>
                <p>专注于客单价，转化率提升！</p>
                <p>便捷高效，助力各大商家提升客单价，</p>
                <p>客户引导，提高复购，</p>
                <p>只为更好的服务每一位用户。</p>
             </div>
            <div class="rightBox">
                <div class="aboutUs">
                    <p class="title">关于我们</p>
                    <p class="cur-poi">了解我们</p>
                    <p class="cur-poi">合作咨询</p>
                    <p class="cur-poi">联系我们</p>
                </div>
                <div class="qrCode">
                    <p class="title">下载CERESHOP</p>
                    <img src="../../../static/image/qrcode.png" alt="">
                </div>
            </div>
        </div> -->
      </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang = "scss" scoped>
.footer{
    width: 100%;
    height: 170px;
    background-color: #000000;
    opacity: 0.82;
    color: #9e9c9c;
    overflow: hidden;
    font-size:14px;
    .banxin{
        width: 1252px;
        height: 100%;
        margin: 0 auto;
        margin-top: 40px;
        text-align: center;
        word-wrap: break-all;
        p{
            font-size: 14px;
            line-height: 30px;
        }
        /* .top{
            margin-top: 100px;
            display: flex;
            margin-bottom: 38px;
            text-align: center;
            .leftBox{
                flex: 1;
                display: flex;
                flex-direction: column;
                .title{
                    font-size: 16px;
                    margin-bottom: 33px;
                }
                .number{
                    font-size: 40px;
                    margin-bottom: 12px;
                    font-weight: 500;
                }
                .time{
                    font-size: 18px;
                    margin-bottom: 33px;
                }
                .consult{
                    cursor: pointer;
                    margin: 0 auto;
                    width: 220px;
                    height: 36px;
                    line-height: 36px;
                    border: 1px solid #FFFFFF;
                    box-sizing: border-box;
                    opacity: 0.6;
                }
            }
            .centerBox{
                flex: 1;
                border-left: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                border-right: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                p{
                    font-size: 20px;
                    line-height: 25px;
                }
                .title{
                    margin-bottom: 33px;
                }
            }
            .rightBox{
                flex: 1;
                display: flex;
                .aboutUs{
                    flex: 1;
                    p{
                        margin-bottom: 20px;
                    }
                    .title{
                        margin-bottom: 33px;
                    }
                }
                .qrCode{
                    flex: 1;
                    .title{
                        margin-bottom: 33px;
                    }
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
            }
        }
        .bottom{
            text-align: center;
            font-size: 12px;
            line-height: 24px;
            color: #444444;
        } */
    }
    .topColor
    {
        height: 5px;
        background-color: red;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue